import FileUpload from './file-upload';
import Log from './log';
import jQuery from 'jquery';
import '@vendor/doka.css';
import { browser } from '$app/environment';
import Doka from './doka';

function getUrlExtension(url) {
  return url.split(/\#|\?/)[0].split('.').pop().trim();
}

function showLoading() {
  jQuery('body').append(
    '<div id="image-upload-loading-container" style="position: fixed; z-index: 1002; background: black; color: white; top: 0px; left: 0px; right: 0px; bottom: 0px; display: flex; align-items: center; justify-content: center;"><span style="font-weight: 500; font-size: 13px; color: rgba(0, 0, 0, 0.8); background: hsla(0, 0%, 100%, 0.75); border-radius: 9999em; line-height: 2; padding: 0 1em; margin: 0; box-shadow: 0 0.125em 1em rgba(0, 0, 0, 0.2);">Loading image<span></div>'
  );
}

function hideLoading() {
  jQuery('#image-upload-loading-container').remove();
}

export default {
  attach: async function (fileInput, successFn, progressFn, options) {
    let cropper;

    if (options['cropper']) {
      cropper = options['cropper'];
    } else if (browser) {
      cropper = Doka().create({
        utils: ['crop'],
        cropAspectRatio: 1,
        onloaderror: function (x) {
          console.log(x);
        },
        allowButtonCancel: false,
      });
    }

    const { default: heic2any } = await import('heic2any');

    options['beforeFileAdded'] = function (uppy, file) {
      var dokaEditFile = function (file) {
        var id = Math.random().toString(36).substr(2, 9);
        var fileExt = getUrlExtension(file.name);
        file.name = id + '.' + fileExt;
        file.meta.handledByDoka = true;
        file.isRemote = false;
        file.remote = null;

        var editFile = function () {
          cropper.edit(file.data).then(function (output) {
            if (!output || !output.file || !output.file.size || output.file.size <= 0) {
              uppy.addFile(file);
              return;
            }
            try {
              file.data = new File([output.file], file.data.name, {
                type: file.data.type,
              });
            } catch (err) {
              Log.info(`[Image Upload] [error] [${file.name}]: ${err}`, true);
            }

            try {
              uppy.addFile(file);
            } catch (err) {
              Log.info(`[Image Upload] [error] [${file.name}]: ${err}`, true);
            }
          });
        };

        if (file.type == 'image/heic' || (file.type == 'image/heif' && browser)) {
          showLoading();

          try {
            heic2any({
              blob: file.data,
              toType: 'image/jpeg',
              quality: 1,
            })
              .then(function (resp) {
                hideLoading();
                file.data = resp;
                file.type = 'image/jpeg';

                editFile();
              })
              .catch((err) => {
                Log.info(`[Image Upload] [${file.name}] heic / heif conversion failed | err: ${err}`, true);
                hideLoading();
              });
          } catch (err) {
            Log.info(`[Image Upload] [${file.name}] heic / heif conversion failed | err: ${err}`, true);
            hideLoading();
            editFile();
          }
        } else {
          editFile();
        }
      };

      if (file.meta && file.meta.handledByDoka) {
        return true;
      } else {
        dokaEditFile({ ...file });
        return false;
      }
    };

    options['uploadTypes'] = ['image/*', '.heic', '.heif'];
    return FileUpload.attach(fileInput, successFn, progressFn, options);
  },
};
